import React from "react";
import axios from "axios";
import Footer from "./partial/Footer";
import Query from "./Cmpnt/Query_sec";
import Admission from "./Admission_process"; 

import Studentslider from "./Cmpnt/Student_trust";
import Goalslider from "./Cmpnt/Goals";
import Job from "./Job_everyone";

import Faq from "./Cmpnt/Faq";
import Councelor from "./Cmpnt/Councelor";
import Intern_top from "./Internship_top"; 
import Job_portal from "./Job_portal";
import Top_companies from "./Top_companies"; 
import { cmsdetail } from "./Api_list";
import { Helmet } from "react-helmet";


const Job_internship = () => {
    const [ post, setPost ] = React.useState( null );
    React.useEffect(()=>{
        var headerData = {"headers":{
            "Accept": "application/json",
            "Content-Type": "application/json",
            "authorization": window.HEADERSAUTH,
          }}  
        axios.get(cmsdetail+'job-and-internship', headerData).then(( response )=>{
            setPost( response.data );
        })
    }, []) 
    if( !post ) return null;
    let getData = post.data;
    return (
        <>
        <Helmet>
            <title>{(getData != null) ? getData.meta_title : 'Careereduversity'}</title> 
            <meta name="title" content={(getData != null) ? getData.meta_title : 'Careereduversity'} />
            <meta name="description" content={(getData != null) ? getData.meta_description : 'Careereduversity'} />
            <meta name="keywords" content={(getData != null) ? getData.meta_keyword : 'Careereduversity'} />
            <meta property="og:title" content={(getData != null) ? getData.meta_title : 'Careereduversity'} />
            <meta property="og:image" content={(getData != null) ?  window.IMGURL + getData.image : 'Careereduversity'}/>
            <meta property="og:description" content={(getData != null) ? getData.meta_description : 'Careereduversity'} />
            <meta property="og:url" content={window.APPURL} />
        </Helmet>
            <Intern_top />
            <Top_companies />
            <Goalslider />

            <Job />

            <Job_portal />
            <Councelor />
            
            <Studentslider />
            <Faq />
            <Admission />
            <Query />
            <Footer />
        </>
    )
}

export default Job_internship;